import { DeploymentType, WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import _ from 'lodash';
import {
	addDefaultFeatureCanariesForOnPrem,
	captureConfigurationsFromPlugin,
	captureNavigationTabsConfiguration,
} from 'Configuration/utils';

const handleCommonDefaults = (_configuration: WorkspaceConfiguration) => {};

const handleDefaultsForOnPrem = (_configuration: WorkspaceConfiguration) => {
	_configuration.deploymentType = DeploymentType.OnPrem;
	addDefaultFeatureCanariesForOnPrem(_configuration);
	captureConfigurationsFromPlugin(_configuration);
	captureNavigationTabsConfiguration(_configuration);
};

const handleDefaultsForCloud = (_configuration: WorkspaceConfiguration) => {
	_configuration.deploymentType = DeploymentType.Cloud;
};

export const handleConfigurationDefaults = (configuration: WorkspaceConfiguration) => {
	handleCommonDefaults(configuration);
	if (IS_ON_PREM) {
		handleDefaultsForOnPrem(configuration);
	} else {
		handleDefaultsForCloud(configuration);
	}
	return configuration;
};
